module.exports = __webpack_public_path__ + "img/more-dots-sr.357a263a.svg";